import React from "react";
import { Outlet } from "react-router-dom";
import Adminheader from "../components/admin/Adminheader";
import Navsetting from "../components/admin/Navsetting";
import style from "./Adminroot.module.css";
const Adminroot=()=>{
    return(
        <>
            <div className={style.rcircle}></div>
            <Adminheader/>
            <div className={style.container}>
                <Outlet/>
                <Navsetting/>
            </div>
            <div className={style.lcircle}></div>
        </>
    )
}
export default Adminroot